import Tile from '@/components/board/Tile';
import { MINIMUM_TILE_WIDTH, MINIMUM_TILE_HEIGHT } from '@/constants';

export default {
	components: {
		Tile,
	},
	data() {
		return {
			scale: this.stage.cat_scale,
			minimumTileCount: this.stage.minimum_tiles,
			tileWidth: this.$store.state.config.general.cat_width,
			tileHeight: this.$store.state.config.general.cat_height,
			rowCount: 0,
			columnCount: 0,
			tileCount: 0,
		};
	},
	methods: {
		calculateTileSize() {
			let tileWidth = this.tileWidth;
			let tileHeight = this.tileHeight;

			while (this.tileCount < this.minimumTileCount) {
				tileWidth = Math.floor(this.tileWidth * this.scale);
				tileHeight = Math.floor(this.tileHeight * this.scale);

				this.columnCount = Math.floor(this.$el.clientWidth / tileWidth);
				this.rowCount = Math.floor(this.$el.clientHeight / tileHeight);

				this.tileCount = this.columnCount * this.rowCount;

				if (this.tileCount < this.minimumTileCount) {
					this.scale -= 0.05;
				}
			}

			this.tileWidth = tileWidth;
			this.tileHeight = tileHeight;

			if (!this.stage.final_stage) {
				this.reduceGrid();
			}

			this.overrideCalculatedSizes();
		},
		overrideCalculatedSizes() {
			this.tileWidth = this.tileWidth > MINIMUM_TILE_WIDTH ? this.tileWidth : MINIMUM_TILE_WIDTH;
			this.tileHeight = this.tileHeight > MINIMUM_TILE_HEIGHT
				? this.tileHeight : MINIMUM_TILE_HEIGHT;
		},
		reduceGrid() {
			let columnCount = this.columnCount;
			let rowCount = this.rowCount;
			let tileCount = this.tileCount;

			while (tileCount > this.minimumTileCount) {
				const gridElememtToReduce = columnCount > rowCount ? "column" : "row";

				if (gridElememtToReduce === "column") {
					columnCount -= 1;
				} else if (gridElememtToReduce === "row") {
					rowCount -= 1;
				}

				tileCount = columnCount * rowCount;

				if (Math.abs(tileCount - this.minimumTileCount)
					< Math.abs(this.tileCount - this.minimumTileCount)) {
					this.tileCount = tileCount;
					this.columnCount = columnCount;
					this.rowCount = rowCount;
				}
			}
		},
	},
	mounted() {
		this.calculateTileSize();
	},
};



// WEBPACK FOOTER //
// ./src/mixins/tile-sizer.js